var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"2"}},[_c('v-img',{attrs:{"src":require("../../public/static/logo_ultraip.png")}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }